<template>
  <div>
    <el-input
      placeholder="Please input"
      :type="showPassword ? 'text' : 'password'"
      :value="(value || '').toString()"
      @input="value=>$emit('input', value)"
    >
      <el-button
        slot="append"
        icon="el-icon-view"
        @click="showPassword = !showPassword"
        tabindex="-1"
      ></el-button>
    </el-input>
  </div>
</template>

<script>
export default {
  props: {
    value: { required: false, default: '' },
    autocomplete: { required: false, default: '', type: String }
  },
  data () {
    return {
      showPassword: false
    }
  }
}
</script>




// WEBPACK FOOTER //
// PasswordInput.vue?eb52cf6e